/**
 * The two heroes of the front screens: C0's own man (the blue-coated `hero`) and woman (`heroF`, which a
 * woman's save wears in play: `lookOf`), both dressed as in the world, so what is picked here is what is played.
 */
export const FRONT_M: { sprite: string; outfit: string[] } = { sprite: 'hero', outfit: ['hero'] };
export const FRONT_F: { sprite: string; outfit: string[] } = { sprite: 'heroF', outfit: ['hero'] };
/** The woman who stands beside him in the pictures: C0's white-robed female figure, so the pair reads at a glance. */
export const FRONT_DUO_F: { sprite: string; outfit: string[] } = { sprite: 'heroWudangF', outfit: [] };
